import { forwardRef } from 'react';

import cx from 'classnames';
import { createPortal } from 'react-dom';

import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';
import Settings from 'components/shared/Icon/icons/Settings';
import Modal from 'components/shared/Modal';

import { IBaseSearchFilterButtonProps } from '../types';
import { useBaseSearchFilterButton } from './functions';
import s from './index.module.css';

const BaseSearchFilterButton = forwardRef<HTMLDivElement, IBaseSearchFilterButtonProps>(
  (
    {
      isActive,
      renderFilterForm,
      onDelete,
      className,
      showDeleteButton,
      showText,
      isRoundButton,
      numberOfFilters,
      isShowNumberOfFilters = true,
      buttonName = 'Filter Content Pages',
      isSmallSizeFilterButton = false,
    },
    ref,
  ) => {
    const { isFilterFormModalOpened, handleClick, handleClose } = useBaseSearchFilterButton();
    const modalProps = { noPadding: true, size: 'md', withoutCloseBtn: true };

    return (
      <>
        <div
          className={cx(
            s.wrapper,
            isActive && s.button,
            isRoundButton && s.roundButtonWrapper,
            isSmallSizeFilterButton && s.smallSizeButtonWrapper,
            isActive && isRoundButton && s.roundButton,
            className,
            { [s.default]: !isActive },
          )}
          data-tip=""
          data-for="filter"
          onClick={handleClick}
        >
          <div className={cx(s.content, isRoundButton && s.roundButtonContent)}>
            {isRoundButton ? (
              <>
                <Icon component={Settings} className={s.roundButtonSetting} anchorRef={ref} />
                {isActive && isShowNumberOfFilters && <div className={s.filtersCount}>{numberOfFilters}</div>}
              </>
            ) : (
              <>
                <Icon component={Settings} className={s.settingsIcon} anchorRef={ref} />
                {showText && <div className={s.text}>{isActive ? 'Applied Filters' : buttonName} </div>}
              </>
            )}
          </div>
          {isActive && !isSmallSizeFilterButton && showDeleteButton && (
            <div className={s.clear} onClick={onDelete}>
              <Icon component={Close} />
            </div>
          )}
        </div>
        {isActive && isSmallSizeFilterButton && showDeleteButton && (
          <div className={s.clear} onClick={onDelete}>
            <Icon component={Close} />
          </div>
        )}
        {isFilterFormModalOpened &&
          createPortal(
            <div onClick={(evt) => evt.stopPropagation()}>
              {/*@ts-ignore*/}
              <Modal isOpen={true} {...modalProps}>
                {renderFilterForm({ onClose: handleClose })}
              </Modal>
            </div>,
            document.body,
          )}
      </>
    );
  },
);

export default BaseSearchFilterButton;
